// Media list for the gallery dialog from the chassis plate photo taken on the
// iPad at the start of the control. Controls made before the photo existed
// have none.
export function chassisPhotoMedia(chassisPhotoUrl) {
  if (!chassisPhotoUrl) {
    return []
  }
  return [{ mediaType: 'image', url: chassisPhotoUrl }]
}

// VIN read on the chassis plate photo (or typed by the inspector) and whether
// it is the VIN of the chassis the control was recorded on. Controls made
// before the VIN was read have none.
export function scannedVinInfo({
  scannedVin,
  vinSource,
  scannedVinMatchesChassis,
}) {
  if (!scannedVin) {
    return null
  }
  return {
    vin: scannedVin,
    sourceKey:
      vinSource === 'manual'
        ? 'controls-detail.vin-source-manual'
        : 'controls-detail.vin-source-ocr',
    mismatch: scannedVinMatchesChassis === false,
  }
}
